import Home from "./views/home";
import NotAuthorized from "./components/not-authorized";
import PageNotFound from "./components/page-not-found";
import ContractList from "./views/contracts/contracts";
import ContractDetails from "./views/contracts/details";
import ContractAdd from "./views/contracts/add";
import ContractEdit from "./views/contracts/edit";
import ContractCopy from "./views/contracts/copy";
import ContractFile from "./views/contracts/file";
import ContractDashboard from "./views/contracts/dashboard";
import OpportunitiesDashboard from "./views/opportunities/dashboard";
import SitesDashboard from "./views/sites/dashboard";
import InformationUpdates from "./views/opportunities/information-updates";
import SitesIndex from "./views/sites/sites";
import SiteDetails from "./views/sites/details";
import SiteAdd from "./views/sites/add";
import SiteEdit from "./views/sites/edit";
import SitesNoContract from "./views/sites/no-contract";
import SitesRequireContract from "./views/sites/require-contract";
// import SitesMySites from "./views/sites/my-sites";
import SiteContactForm from "./views/sites/contact-form";
import OpportunityIndex from "./views/opportunities/opportunities";
import OpportunitiesMyOpportunities from "./views/opportunities/my-opportunities";
import OpportunityDetails from "./views/opportunities/details";
import OpportunityAdd from "./views/opportunities/opportunityAdd";
import OpportunityEdit from "./views/opportunities/opportunityEdit";
import OpportunityPublish from "./views/opportunities/publish";
import OpportunityCopy from "./views/opportunities/copy";
import RequestDetails from "./views/requests/details";
import StudentDetails from "./views/students/details";
import StudentIndex from "./views/students/students";
import StudentOpportunities from "./views/students/opportunities";
import ApplicationProgress from "./views/students/application-progress";
import CompletedPlacements from "./views/students/completed-students";
import PendingStudents from "./views/students/pending-students";
import ApprovedStudents from "./views/students/approved-students";
import StudentOpportunity from "./views/students/student-opportunity-details";
import TranslationalTeamsIndex from "./views/translationalteams/teams";
import TranslationalTeamAdd from "./views/translationalteams/add";
import TranslationalTeamEdit from "./views/translationalteams/edit";
import TranslationalTeamDetails from "./views/translationalteams/details";
import Roles from "./misc/roles";
import ContentDetails from "./views/content/details";

import OpportunityTermAndClassConfig from "./views/opportunities/config/config";
// import OpportunityConfigTerm from "./views/opportunities/config/term";
// import OpportunityConfigClass from "./views/opportunities/config/class";

const USER_ROLES = Roles;

export const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    display: "Home",
    meta: {
      roles: [USER_ROLES.all]
    }
  },
  {
    path: "/impersonation/:asuriteId",
    name: "impersonation",
    component: Home,
    props: true,
    display: "Impersonation",
    meta: {
      roles: [USER_ROLES.impersonation]
    }
  },
  {
    path: "/stopimpersonation",
    name: "stopimpersonation",
    component: Home,
    props: true,
    display: "StopImpersonation"
  },
  {
    path: "/not-authorized",
    name: "notAuthorized",
    component: NotAuthorized,
    display: "Not Authorized"
  },
  {
    path: "/contracts",
    name: "contractList",
    component: ContractList,
    display: "Contracts",
    meta: {
      roles: [USER_ROLES.contractManager, USER_ROLES.contractViewer]
    }
  },
  {
    path: "/contracts/dashboard",
    name: "contractDashboard",
    display: "Contract Dashboard",
    component: ContractDashboard,
    meta: {
      roles: [USER_ROLES.contractManager, USER_ROLES.contractViewer]
    }
  },
  {
    path: "/contracts/add",
    name: "contractAdd",
    display: "Contract Add",
    component: ContractAdd,
    meta: {
      roles: [USER_ROLES.contractManager]
    }
  },
  {
    path: "/contracts/edit/:id",
    name: "contractEdit",
    display: "Contract Edit",
    component: ContractEdit,
    props: true,
    meta: {
      roles: [USER_ROLES.contractManager]
    }
  },
  {
    path: "/contracts/copy/:id",
    name: "contractCopy",
    display: "Contract Copy",
    component: ContractCopy,
    props: true,
    meta: {
      roles: [USER_ROLES.contractManager]
    }
  },
  {
    path: "/contracts/:id",
    name: "contract",
    component: ContractDetails,
    display: "Contract",
    props: true,
    meta: {
      roles: [USER_ROLES.contractManager, USER_ROLES.contractViewer]
    }
  },
  {
    path: "/contracts/:contractId/file",
    name: "contractFile",
    display: "Contract File",
    component: ContractFile,
    props: true,
    meta: {
      roles: [USER_ROLES.contractManager]
    }
  },
  {
    path: "/opportunities/information-updates",
    name: "informationUpdates",
    display: "Information Updates",
    component: InformationUpdates,
    meta: {
      roles: [USER_ROLES.opportunitiesViewer, USER_ROLES.opportunitiesManager]
    }
  },
  {
    path: "/opportunities/dashboard",
    name: "opportunityDashboard",
    display: "Opportunity Dashboard",
    component: OpportunitiesDashboard,
    meta: {
      roles: [USER_ROLES.opportunitiesViewer, USER_ROLES.opportunitiesManager]
    }
  },
  {
    path: "/sites",
    name: "sites",
    component: SitesIndex,
    display: "Active",
    meta: {
      roles: [USER_ROLES.sitesManager, USER_ROLES.sitesViewer]
    }
  },
  {
    path: "/sites/dashboard",
    name: "sitesDashboard",
    display: "Sites Dashboard",
    component: SitesDashboard,
    meta: {
      roles: [
        // USER_ROLES.admin,
        USER_ROLES.sitesManager,
        USER_ROLES.sitesViewer
      ]
    }
  },
  {
    path: "/sites/noContract",
    name: "sitesNoContract",
    component: SitesNoContract,
    display: "No Contracts",
    meta: {
      roles: [
        // USER_ROLES.admin,
        USER_ROLES.sitesManager
      ]
    }
  },
  // {
  //   path: "/sites/mySites",
  //   name: "sitesMySites",
  //   component: SitesMySites,
  //   display: "My Sites",
  //   meta: {
  //     roles: [USER_ROLES.admin, USER_ROLES.advisor]
  //   }
  // },
  {
    path: "/sites/requireContract",
    name: "sitesRequireContract",
    component: SitesRequireContract,
    display: "Require Contract",
    meta: {
      roles: [
        // USER_ROLES.admin,
        USER_ROLES.sitesManager
      ]
    }
  },
  {
    path: "/sites/add",
    name: "siteAdd",
    component: SiteAdd,
    display: "Add",
    meta: {
      roles: [
        // USER_ROLES.admin,
        USER_ROLES.sitesManager
      ]
    }
  },
  {
    path: "/sites/edit/:siteId",
    name: "siteEdit",
    component: SiteEdit,
    display: "Edit",
    props: true,
    meta: {
      roles: [
        // USER_ROLES.admin,
        USER_ROLES.sitesManager
      ]
    }
  },
  {
    path: "/sites/:siteId",
    name: "site",
    component: SiteDetails,
    props: true,
    display: "Site Details",
    meta: {
      roles: [
        // USER_ROLES.admin,
        USER_ROLES.sitesManager,
        USER_ROLES.sitesViewer
      ]
    }
  },
  {
    path: "/opportunities",
    name: "opportunities",
    component: OpportunityIndex,
    display: "Active",
    meta: {
      roles: [USER_ROLES.opportunitiesViewer, USER_ROLES.opportunitiesManager]
    }
  },
  {
    path: "/opportunities/myOpportunities",
    name: "opportunitiesMyOpportunities",
    component: OpportunitiesMyOpportunities,
    display: "My Opportunities",
    meta: {
      roles: [USER_ROLES.opportunitiesManager]
    }
  },
  {
    path: "/opportunities/add",
    name: "opportunityAdd",
    component: OpportunityAdd,
    display: "Add",
    props: true,
    meta: {
      roles: [USER_ROLES.opportunitiesManager]
    }
  },
  {
    path: "/opportunities/edit/:opportunityId",
    name: "opportunityEdit",
    component: OpportunityEdit,
    display: "Edit",
    props: route => ({
      step: +route.query.step,
      opportunityId: route.params.opportunityId
    }),
    meta: {
      roles: [USER_ROLES.opportunitiesManager]
    }
  },
  {
    path: "/opportunities/publish",
    name: "opportunityPublish",
    component: OpportunityPublish,
    display: "Publish",
    meta: {
      roles: [USER_ROLES.opportunitiesManager]
    }
  },
  {
    path: "/opportunities/copy",
    name: "opportunityCopy",
    component: OpportunityCopy,
    display: "Copy",
    meta: {
      roles: [USER_ROLES.opportunitiesManager]
    }
  },
  // 10/21/2024
  {
    path: "/opportunities/config",
    name: "opportunityTermAndClassConfig",
    display: "Opportunity Configurations",
    component: OpportunityTermAndClassConfig,
    props: true,
    meta: {
      roles: [USER_ROLES.opportunitiesManager]
    }
  },
  {
    path: "/opportunities/:opportunityId",
    name: "opportunity",
    component: OpportunityDetails,
    props: true,
    display: "Opportunity Details",
    meta: {
      roles: [USER_ROLES.opportunitiesViewer, USER_ROLES.opportunitiesManager]
    }
  },
  {
    path: "requests/:requestId",
    name: "request",
    component: RequestDetails,
    props: true,
    display: "Request Details",
    meta: {
      roles: [USER_ROLES.admin, USER_ROLES.contractManager, USER_ROLES.advisor]
    }
  },
  {
    path: "/sites/contact/add/:siteId",
    name: "addContact",
    component: SiteContactForm,
    props: true,
    display: "Add Contact",
    meta: {
      roles: [USER_ROLES.sitesManager]
    }
  },
  {
    path: "/sites/contact/edit/:contactId",
    name: "editContact",
    component: SiteContactForm,
    props: true,
    display: "Edit Contact",
    meta: {
      roles: [USER_ROLES.sitesManager]
    }
  },
  {
    path: "/students",
    name: "students",
    component: StudentIndex,
    props: true,
    display: "Students",
    meta: {
      roles: [USER_ROLES.studentPlacementsManager]
    }
  },
  {
    path: "/students/opportunities",
    name: "studentOpportunities",
    component: StudentOpportunities,
    props: true,
    display: "Student Opportunities",
    meta: {
      roles: [USER_ROLES.studentPlacementsManager]
    }
  },
  {
    path: "/students/application-progress",
    name: "applicationProgress",
    component: ApplicationProgress,
    display: "Application Progress",
    meta: {
      roles: [USER_ROLES.studentPlacementsManager]
    }
  },
  {
    path: "/students/completed",
    name: "completedPlacements",
    component: CompletedPlacements,
    display: "Completed Placements",
    meta: {
      roles: [USER_ROLES.studentPlacementsManager]
    }
  },
  {
    path: "/students/pending",
    name: "pendingStudents",
    component: PendingStudents,
    display: "Pending Students",
    meta: {
      roles: [USER_ROLES.studentPlacementsManager]
    }
  },
  {
    path: "/students/approved",
    name: "studentsApproved",
    component: ApprovedStudents,
    display: "Approved Students",
    meta: {
      roles: [USER_ROLES.studentPlacementsManager]
    }
  },
  {
    path: "/students/opportunities/:studentOpportunityId",
    name: "studentOpportunityDetails",
    component: StudentOpportunity,
    props: true,
    display: "Student Opportunity",
    meta: {
      roles: [USER_ROLES.studentPlacementsManager]
    }
  },
  {
    path: "/students/application-progress",
    name: "applicationProgress",
    component: ApplicationProgress,
    display: "Application Progress",
    meta: {
      roles: [USER_ROLES.studentPlacementsManager]
    }
  },
  {
    path: "/students/completed",
    name: "completedPlacements",
    component: CompletedPlacements,
    display: "Completed Placements",
    meta: {
      roles: [USER_ROLES.studentPlacementsManager]
    }
  },

  {
    path: "/students/:id",
    name: "studentDetails",
    component: StudentDetails,
    props: true,
    display: "Student",
    meta: {
      roles: [USER_ROLES.studentPlacementsManager]
    }
  },
  {
    path: "/translational-teams",
    name: "translationalTeams",
    component: TranslationalTeamsIndex,
    display: "Translational Teams",
    meta: {
      roles: [USER_ROLES.admin, USER_ROLES.translationalTeam]
    }
  },
  {
    path: "/translational-teams/add",
    name: "translationalTeamAdd",
    component: TranslationalTeamAdd,
    display: "Add",
    meta: {
      roles: [USER_ROLES.admin, USER_ROLES.translationalTeam]
    }
  },
  {
    path: "/translational-teams/edit/:translationalTeamId",
    name: "translationalTeamEdit",
    component: TranslationalTeamEdit,
    props: true,
    display: "Edit",
    meta: {
      roles: [USER_ROLES.admin, USER_ROLES.translationalTeam]
    }
  },
  {
    path: "/translational-teams/:translationalTeamId",
    name: "translationalTeam",
    component: TranslationalTeamDetails,
    props: true,
    display: "Translational Team Details",
    meta: {
      roles: [USER_ROLES.admin, USER_ROLES.translationalTeam]
    }
  },
  {
    path: "/:id/:name/",
    name: "contentDetails",
    component: ContentDetails,
    props: true,
    display: "Details",
    meta: {
      roles: [USER_ROLES.student, USER_ROLES.contentManager]
    }
  },
  {
    path: "*",
    component: PageNotFound
  }
];
